(function() {
    'use strict';

    angular.module('doclr.statistieken', ['doclr.resources.api', 'n3-charts.linechart'])
        .config(function($stateProvider) {
            $stateProvider
                .state('statistieken', {
                    url: '/statistieken',
                    views: {
                        '' : {
                            templateUrl : '/partials/components/page.with.sidebar.html',
                            resolve: {
                                agendas: function(AgendaOverzicht, praktijkContext) {
                                    return AgendaOverzicht.get(praktijkContext.id).then(function(agendas) {
                                        return [{ uuid: 'praktijk', naam : doclrVertaal.instant('agendalist.header.alleagendas') }].concat(agendas);
                                    });
                                },
                                options : function() {
                                    return {
                                        dag : {
                                            label:   function(d)    { return moment(d).format('D/M'); },
                                            tooltip: function(x, y, series) { return moment(x).format('dddd D MMMM') + ' : ' + y + ' ' + translateLabel(series.label); }
                                        },
                                        week : {
                                            label :   function(d)    { return moment(d).format('D/M'); },
                                            tooltip : function(x, y, series) { return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option2Period') + ' ' + moment(x).format('dddd D MMMM') + ' : ' + y + ' ' + translateLabel(series.label); }
                                        },
                                        maand : {
                                            label :   function(d)    { return moment(d).format('M/YYYY'); },
                                            tooltip : function(x, y, series) { return moment(x).format('MMMM YYYY') + ' : ' + y + ' ' + series.label; }
                                        }
                                    };
                                },
                                afsprakenGrafiek : function(options, borderColor) {
                                    return  {
                                        form : { frequentie : 'dag', tijdstip : 'creatiedatum', series : 'creatieRol', agendaId: 'praktijk' },
                                        options: {
                                            axes: {
                                                x: {key: 'dag', type: 'date' },
                                                y: {type: 'linear'}
                                            },
                                            series: [
                                                {id: 'praktijk', y: 'praktijk', color: '#1f77b4', type: 'area', label: doclrVertaal.instant('partials.statistieken.statistieken.legend.praktijk')},
                                                {id: 'patient', y: 'patient', color: '#ff7f0e', type: 'area', label: doclrVertaal.instant('partials.statistieken.statistieken.legend.patient')}
                                            ],
                                            stacks: [{axis: 'y', series: ['praktijk', 'patient']}],
                                            lineMode: 'linear',
                                            tooltip: {mode: 'scrubber' }
                                        },
                                        toonData: function(data) {

                                            this.data = data.data;
                                            this.options.axes.x.labelFunction = translateLabel(options[this.form.frequentie].label);
                                            this.options.tooltip.formatter = options[this.form.frequentie].tooltip;
                                            this.options.series = _.map(data.series, function(s) {
                                                return {id: s.series, y: s.series, color: borderColor(s.kleur), type: 'column', label: translateLabel(s.naam) };
                                            });
                                            this.options.stacks = [{axis: 'y', series: _.pluck(data.series, 'series')}];

                                        },
                                    };
                                }
                            },
                            controller: function($scope, agendas,  praktijkContext, Statistieken, afsprakenGrafiek, $http, csvDownloader) {
                                $scope.agendas = agendas;
                                $scope.afsprakenGrafiek = afsprakenGrafiek;
                                $scope.getFrequentie = () => translateFrequentie($scope.afsprakenGrafiek.form.frequentie);
                                $scope.getGroupBy = () => translateGroepering($scope.afsprakenGrafiek.form.tijdstip);
                                Statistieken.getPeriode(praktijkContext.id, $scope.afsprakenGrafiek.form).then(function(data) {
                                    afsprakenGrafiek.toonData(data);
                                });

                                $scope.setFrequentie = function(f) {
                                    $scope.afsprakenGrafiek.form.frequentie = f;
                                    Statistieken.getPeriode(praktijkContext.id, $scope.afsprakenGrafiek.form).then(function(data) {
                                        afsprakenGrafiek.toonData(data);
                                    });
                                };

                                $scope.setTijdstip = function(t) {
                                    $scope.afsprakenGrafiek.form.tijdstip = t;
                                    Statistieken.getPeriode(praktijkContext.id, $scope.afsprakenGrafiek.form).then(function(data) {
                                        afsprakenGrafiek.toonData(data);
                                    });
                                };

                                $scope.setSeries = function(s) {
                                    $scope.afsprakenGrafiek.form.series = s;
                                    Statistieken.getPeriode(praktijkContext.id, $scope.afsprakenGrafiek.form).then(function(data) {
                                        afsprakenGrafiek.toonData(data);
                                    });
                                };

                                $scope.setAgendaId = function() {
                                    Statistieken.getPeriode(praktijkContext.id, $scope.afsprakenGrafiek.form).then(function(data) {
                                        afsprakenGrafiek.toonData(data);
                                    });
                                };

                                $scope.exportNewOrUpdatedAppointments = function(){
                                    doclrModal.datepickerModal(
                                        doclrVertaal.instant('partials.export.new.or.updated.appointments.titel'),
                                        doclrVertaal.instant('partials.export.new.or.updated.appointments.vraag'),
                                        doclrVertaal.instant('partials.export.new.or.updated.appointments.datum'),
                                        new Date().toISOString().slice(0, 10))
                                        .then((date)=> {
                                            if(date){
                                                const params = {dagTot: date, dagVan: date};
                                                $http({
                                                    method: 'GET',
                                                    url: '/api/org/'+ praktijkContext.id +'/reports/new-updated-appointments.csv',
                                                    params: params
                                                })
                                                    .then((response)=>csvDownloader.download(response,'export-new-or-updated-appointments_' + date));
                                            }
                                        });
                                };

                            }
                        },
                        'content@statistieken': {
                            templateUrl: '/partials/statistieken/statistieken.html'
                        },
                        'sidebar@statistieken' : {
                            templateUrl: '/partials/statistieken/statistieken.sidebar.html'
                        }
                    }

                });
        });

    function translateLabel (label){
        const vertaling = doclrVertaal.translateTypeByDuthName(label);
        if(vertaling){
            return vertaling;
        }

        if(label === 'door praktijk'){
            return doclrVertaal.instant('partials.statistieken.statistieken.legend.praktijk');
        }

        if(label === 'door patiÃ«nt'){
            return doclrVertaal.instant('partials.statistieken.statistieken.legend.patient');
        }

        return label;
    }

    function translateFrequentie (frequentie){
        if(frequentie === 'week'){
            return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option2Period');
        }

        if(frequentie === 'dag'){
            return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option1Period');
        }
        if(frequentie === 'maand'){
            return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option3Period');
        }
        return frequentie;
    }

    function translateGroepering(groepering){
        if(groepering === 'creatiedatum'){
            return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option1Grouping');
        }

        if(groepering === 'afspraakdatum'){
            return doclrVertaal.instant('partials.statistieken.statistieken.sidebar.option2Grouping');
        }

        return groepering;

    }
})();